import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

/**
 * Obtiene el reporte de ventas con cortesías filtrado por días administrativos.
 * Devuelve un arreglo de tickets, cada uno con su detalle de ventas y resumen.
 */
export async function getReporteVentasCortesias(ids_dia: number[]) {
  try {
    const params = ids_dia.length ? `?ids_dia=${ids_dia.join(',')}` : '';
    const response = await axios.get(`${API_URL}cortesias/reporte-ventas-cortesias${params}`);
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error al obtener el reporte de ventas con cortesías:', error);
    throw error;
  }
}
